import { z } from 'zod';

export const searchParamsPageScheme = z.object({
  page: z.coerce.number().catch(1),
  per_page: z.coerce.number().catch(10),
});

export const searchParamsQueryScheme = z.object({
  query: z.string().trim().catch(null),
});

export function buildSearchParamsSortScheme<const T extends string[]>(fields: T) {
  return z.object({
    sort_field: z.custom<T[number]>(value => fields.includes(value)).catch(null),
    sort_order: z.union([z.literal(-1), z.literal(1), z.literal('-1'), z.literal('1')])
      .transform((value) => (Number(value) as -1 | 1))
      .catch(null),
  });
}
